import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AccountService} from 'src/app/services/account.service';
import {UserService} from 'src/app/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {AccountCategoryService} from 'src/app/services/account-category.service';
import {ValidateAccountNumber} from 'src/app/validators/iban.validator';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '../../../services/notification.service';
import {AccountCategoryDTO} from '../../../model/accountCategoryDTO';
import {AddAccountDTO} from '../../../model/addAccountDTO';
import {InformDTO} from '../../shared/notification/InformDTO';

@Component({
  templateUrl: './add-account-dialog.component.html',
  styleUrls: ['./add-account-dialog.component.scss']
})
export class AddAccountDialogComponent implements OnInit {

  form: FormGroup;
  accountCategories: AccountCategoryDTO[];
  submitted = false;
  private created = new EventEmitter<boolean>();

  constructor(private builder: FormBuilder,
              private service: AccountService,
              private userService: UserService,
              private router: Router,
              private location: Location,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              public translate: TranslateService,
              public dialogRef: MatDialogRef<AddAccountDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private accountCategoryService: AccountCategoryService) {
    translate.use('nl');
    this.form = builder.group({
      'accountNumber': ['', [Validators.required, ValidateAccountNumber]],
      'accountCategoryId': [null, [Validators.required]],
    });
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {
    this.accountCategoryService.get().subscribe((data) => this.accountCategories = data);
    this.form.get('accountNumber').setValue(this.data.iban);
  }

  create(values) {
    this.submitted = true;
    if (this.form.invalid) {
      this.notificationService.warning('formulier niet correct ingevuld');
      return;
    }
    if (this.data.iban != null && values.accountNumber.indexOf(this.data.iban) === -1) {
      this.notificationService.warning('rekeningnummer uit het bestand komt niet overeen met het ingevoerde rekeningnummer');
      return;
    }

    const dto: AddAccountDTO = {
      clientId: this.data.clientId,
      accountNumber: values.accountNumber,
      accountCategoryId: values.accountCategoryId
    };

    this.service.add(dto).subscribe(
      () => this.close(true),
      error => this.handleError(error),
      () => this.submitted = false
    );
  }

  private handleError(response) {
    if (response.error.message === 'ACCOUNT_UNEXPECTED_ERROR') {
      const data: InformDTO = {header: 'er is iets misgegaan <br><br> de technische dienst is ingelicht <br>wij nemen contact met u op', ok: 'ok'};
      this.notificationService.inform(data).then(() => this.close(false));
    } else {
      this.notificationService.errorResponse(response);
    }
  }

  close(added: boolean) {
    this.created.emit(added);
    this.dialogRef.close();
  }

  public promise() {
    return new Promise<void>((resolve, reject) => this.created.subscribe(created => created ? resolve() : reject()));
  }

}
